import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';
import Picker from "emoji-picker-react";

// import { useStore } from '../../../../hook-store/store';

import './InputEmoji2.css';


const InputEmoji2 = (props) => {
  // console.log('GroupTalkTextItem-props', props);

  const { 
    getInputHandler,
    emojiPickerStyle,
    textAreaStyle,
    nRows,
    inputValue,
   } = props;

  //  console.log('inputData', inputData);
  const [t] = useTranslation('translation');

  // const [store, dispatch] = useStore();
  // const { 
  //   selectedGroupData,
  //   // selectedKuraFileData,
  //   // isGroupMember,
  //  } = store.groupStore;


  const [inputStr, setInputStr] = useState("");
  const [showPicker, setShowPicker] = useState(false);

  // console.log(inputStr)

  useEffect(() => {
    getInputHandler(inputStr)
  },[inputStr]);

  const onEmojiClick = (emojiObject, event) => {
    setInputStr((prevInput) => {
      return prevInput + emojiObject.emoji;
    });
    // setShowPicker(false);
  };

  let emojiInputPickerStyle = {
    display: 'none',
  }

  if (showPicker) {
    // emojiInputPickerStyle = {
    //   display: 'block',
    //   // width: "100%",
    //   maxWidth: "100%",
    //   paddingBottom: "2rem",
    // }
    emojiInputPickerStyle = emojiPickerStyle
  }


  let inputEmoji2Body = (
    <div>
      <div className="inputEmoji2Input">
        <textarea
          style={textAreaStyle ? textAreaStyle : null}
          // value={inputStr}
          value={inputValue}
          rows={nRows ? nRows : 3}
          onChange={(e) => setInputStr(e.target.value)}
        />
        <span className="inputEmoji2DispButton"
          onClick={() => setShowPicker((val) => !val)}
        >
          😀
        </span>
          {/* <img
            className={classes.groupTextItemReplyEmojiButton}
            src="https://icons.getbootstrap.com/assets/icons/emoji-smile.svg"
            onClick={() => setShowPicker((val) => !val)}
          /> */}
      </div>
      <div
        style={emojiInputPickerStyle}
      >
        <div className='inputEmoji2CloseButton'>
          <span
            onClick={() => { setShowPicker(false)}}
          >
            X
          </span>
        </div>
        <Picker 
          // pickerStyle={emojiPickerStyle} 
          onEmojiClick={onEmojiClick} 
          width={'100%'}
          searchDisabled={true} 
          previewConfig={{
            showPreview: false, // This hides the bottom preview bar
          }}
        />
      </div>
    </div>
  );
  



  return (
    <Fragment>
      <div>{inputEmoji2Body}</div>
    </Fragment>
  );
}

export default InputEmoji2;